import { ReactNode } from "react";
import { ButtonBase } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { CardContainer } from "./styles";
import { isMobile } from "../../../utils";

interface CardProps {
  id: string;
  icon: ReactNode;
  children: ReactNode;
  link?: string;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
}

const Container: React.FC<Pick<CardProps, "link">> = ({ children, link }) => {
  return link && link.includes("http") ? (
    <a
      href={link}
      {...(!isMobile()
        ? {
            target: "_blank",
            rel: "noreferrer",
          }
        : {})}
    >
      {children}
    </a>
  ) : (
    <>{children}</>
  );
};

export const Card = ({
  id,
  icon,
  link,
  onClick,
  children,
  disabled,
  className,
}: CardProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled) return;
    if (onClick) {
      onClick();
    } else if (link && !link.includes("http")) {
      navigate(link);
    }
  };

  return (
    <CardContainer id={id} className={className} onClick={handleClick}>
      <ButtonBase disabled={disabled} disableTouchRipple={disabled}>
        <Container link={link}>
          <figure>{icon}</figure>
          <div className="content">{children}</div>
        </Container>
      </ButtonBase>
    </CardContainer>
  );
};
